(function(){
'use strict';

angular.module('classy').constant('ALPHA_2', {
  AW: 'Aruba',
  AF: 'Afghanistan',
  AO: 'Angola',
  AI: 'Anguilla',
  AX: 'Åland Islands',
  AL: 'Albania',
  AD: 'Andorra',
  AN: 'Netherlands Antilles',
  AE: 'United Arab Emirates',
  AR: 'Argentina',
  AM: 'Armenia',
  AS: 'American Samoa',
  AQ: 'Antarctica',
  TF: 'French Southern Territories',
  AG: 'Antigua and Barbuda',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BI: 'Burundi',
  BE: 'Belgium',
  BJ: 'Benin',
  BF: 'Burkina Faso',
  BD: 'Bangladesh',
  BG: 'Bulgaria',
  BH: 'Bahrain',
  BS: 'Bahamas',
  BA: 'Bosnia and Herzegovina',
  BL: 'Saint Barthélemy',
  BY: 'Belarus',
  BZ: 'Belize',
  BM: 'Bermuda',
  BO: 'Bolivia',
  BR: 'Brazil',
  BB: 'Barbados',
  BN: 'Brunei Darussalam',
  BT: 'Bhutan',
  BV: 'Bouvet Island',
  BW: 'Botswana',
  CF: 'Central African Republic',
  CA: 'Canada',
  CC: 'Cocos (Keeling) Islands',
  CH: 'Switzerland',
  CL: 'Chile',
  CN: 'China',
  CI: "Côte d'Ivoire",
  CM: 'Cameroon',
  CD: 'Democratic Republic of the Congo',
  CG: 'Congo',
  CK: 'Cook Islands',
  CO: 'Colombia',
  KM: 'Comoros',
  CV: 'Cape Verde',
  CR: 'Costa Rica',
  CU: 'Cuba',
  CX: 'Christmas Island',
  KY: 'Cayman Islands',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DE: 'Germany',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DK: 'Denmark',
  DO: 'Dominican Republic',
  DZ: 'Algeria',
  EC: 'Ecuador',
  EG: 'Egypt',
  ER: 'Eritrea',
  EH: 'Western Sahara',
  ES: 'Spain',
  EE: 'Estonia',
  ET: 'Ethiopia',
  FI: 'Finland',
  FJ: 'Fiji',
  FK: 'Falkland Islands (Malvinas)',
  FR: 'France',
  FO: 'Faroe Islands',
  FM: 'Federated States of Micronesia',
  GA: 'Gabon',
  GB: 'United Kingdom',
  GE: 'Georgia',
  GG: 'Guernsey',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GN: 'Guinea',
  GP: 'Guadeloupe',
  GM: 'Gambia',
  GW: 'Guinea-Bissau',
  GQ: 'Equatorial Guinea',
  GR: 'Greece',
  GD: 'Grenada',
  GL: 'Greenland',
  GT: 'Guatemala',
  GF: 'French Guiana',
  GU: 'Guam',
  GY: 'Guyana',
  HK: 'Hong Kong',
  HM: 'Heard Island and McDonald Islands',
  HN: 'Honduras',
  HR: 'Croatia',
  HT: 'Haiti',
  HU: 'Hungary',
  ID: 'Indonesia',
  IM: 'Isle of Man',
  IN: 'India',
  IO: 'British Indian Ocean Territory',
  IE: 'Ireland',
  IR: 'Islamic Republic of Iran',
  IQ: 'Iraq',
  IS: 'Iceland',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JE: 'Jersey',
  JO: 'Jordan',
  JP: 'Japan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KG: 'Kyrgyzstan',
  KH: 'Cambodia',
  KI: 'Kiribati',
  KN: 'Saint Kitts and Nevis',
  KR: 'Republic of Korea',
  KW: 'Kuwait',
  LA: "Lao People's Democratic Republic",
  LB: 'Lebanon',
  LR: 'Liberia',
  LY: 'Libya',
  LC: 'Saint Lucia',
  LI: 'Liechtenstein',
  LK: 'Sri Lanka',
  LS: 'Lesotho',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  LV: 'Latvia',
  MO: 'Macao',
  MF: 'Saint Martin',
  MA: 'Morocco',
  MC: 'Monaco',
  MD: 'Republic of Moldova',
  MG: 'Madagascar',
  MV: 'Maldives',
  MX: 'Mexico',
  MH: 'Marshall Islands',
  MK: 'Macedonia',
  ML: 'Mali',
  MT: 'Malta',
  MM: 'Myanmar',
  ME: 'Montenegro',
  MN: 'Mongolia',
  MP: 'Northern Mariana Islands',
  MZ: 'Mozambique',
  MR: 'Mauritania',
  MS: 'Montserrat',
  MQ: 'Martinique',
  MU: 'Mauritius',
  MW: 'Malawi',
  MY: 'Malaysia',
  YT: 'Mayotte',
  NA: 'Namibia',
  NC: 'New Caledonia',
  NE: 'Niger',
  NF: 'Norfolk Island',
  NG: 'Nigeria',
  NI: 'Nicaragua',
  NU: 'Niue',
  NL: 'Netherlands',
  NO: 'Norway',
  NP: 'Nepal',
  NR: 'Nauru',
  NZ: 'New Zealand',
  OM: 'Oman',
  PK: 'Pakistan',
  PA: 'Panama',
  PN: 'Pitcairn',
  PE: 'Peru',
  PH: 'Philippines',
  PW: 'Palau',
  PG: 'Papua New Guinea',
  PL: 'Poland',
  PR: 'Puerto Rico',
  KP: "Democratic People's Republic of Korea",
  PT: 'Portugal',
  PY: 'Paraguay',
  PS: 'Palestine',
  PF: 'French Polynesia',
  QA: 'Qatar',
  RE: 'Réunion',
  RO: 'Romania',
  RU: 'Russian Federation',
  RW: 'Rwanda',
  SA: 'Saudi Arabia',
  SD: 'Sudan',
  SN: 'Senegal',
  SG: 'Singapore',
  GS: 'South Georgia and the South Sandwich Islands',
  SH: 'Saint Helena, Ascension and Tristan da Cunha',
  SJ: 'Svalbard and Jan Mayen',
  SB: 'Solomon Islands',
  SL: 'Sierra Leone',
  SV: 'El Salvador',
  SM: 'San Marino',
  SO: 'Somalia',
  PM: 'Saint Pierre and Miquelon',
  RS: 'Serbia',
  ST: 'Sao Tome and Principe',
  SR: 'Suriname',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SE: 'Sweden',
  SZ: 'Swaziland',
  SC: 'Seychelles',
  SY: 'Syrian Arab Republic',
  TC: 'Turks and Caicos Islands',
  TD: 'Chad',
  TG: 'Togo',
  TH: 'Thailand',
  TJ: 'Tajikistan',
  TK: 'Tokelau',
  TM: 'Turkmenistan',
  TL: 'Timor-Leste',
  TO: 'Tonga',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TV: 'Tuvalu',
  TW: 'Taiwan',
  TZ: 'United Republic of Tanzania',
  UG: 'Uganda',
  UA: 'Ukraine',
  UM: 'United States Minor Outlying Islands',
  UY: 'Uruguay',
  US: 'United States',
  UZ: 'Uzbekistan',
  VA: 'Vatican City',
  VC: 'Saint Vincent and the Grenadines',
  VE: 'Venezuela',
  VG: 'Virgin Islands, British',
  VI: 'Virgin Islands, U.S.',
  VN: 'Viet Nam',
  VU: 'Vanuatu',
  WF: 'Wallis and Futuna',
  WS: 'Samoa',
  YE: 'Yemen',
  ZA: 'South Africa',
  ZM: 'Zambia',
  ZW: 'Zimbabwe'
});
})();